// ESM-Huelle um lib/scripts/pos/CLS_CBankomat.js (Phase 4, Welle 4c).
// Prototype-Stil bleibt vorerst.

// Strict-Mode-Fix (ESM): implizit zugewiesene Sloppy-Mode-Globals.
var voucher, messages, i, expr, sql, ret;
// ---------------------------------------------------------------------------
// CBankomatHandler
//  Provides event handler routines for Bankomat terminal
// ---------------------------------------------------------------------------
function CBankomatHandler(bankomat) {
    this.requestNo = '';
    this.responseType = '';
    this.businessCase = '';
    this.messageText = '';
    this.Display = new CDisplay();
    this.previousResponse = '';
    this.bankomat = bankomat;
    this.SerialPort = require("serialport").SerialPort;
}

CBankomatHandler.prototype.response = function(message) {
    //dump("EVENT Response: " + message + "\n");
    this.responseType = message.charAt(0);
    var me = this;
    var defret = jQuery.Deferred();
    if (me.responseType == 'J') { //Journal
        //neu
        /*	if (!stoppedTransaction) {
        try {
        me.bankomat.stopTransaction();
        } catch (e) {
        log.add(2, "Error", "Case P: Tried to stop non-running transaction!");
        }
        }*/
        //neu
        //return 0;
        //defret.resolve(1);
        //return defret.promise();
        return me.bankomat.stopTransaction('ACK');
    }

    // undefined state, e.g. after reset of point of sale (kassa)

    if (me.bankomat.answerComp == null ||
        typeof me.bankomat.anserComp == undefined) {
        me.messageText = "KEIN ERGEBNIS!";

        var extMessageText;
        if (me.responseType == 'P') {
            extMessageText = message.substr(44, 16);
        } else if (me.responseType == 'N') {
            extMessageText = message.substr(4, 16);
        }

        me.bankomat.dump("RESET B-KASSE: " + me.messageText);

        POS.message.show(me.messageText, "warning", "OK");
        //return 0; // ignore !!!
        return me.bankomat.stopTransaction();
    }

    // else

    me.bankomat.waiting = false;
    var requestNo = '';
    if (me.responseType == 'P')
        requestNo = message.charAt(60);
    else if (me.responseType == 'N')
        requestNo = message.charAt(20);
    else // and for all credit card messages
        requestNo = message.charAt(4);
    log.add(1, "Info", "RequestNo in Response " + requestNo + ",in Request: " + me.requestNo);

    me.businessCase = message.charAt(3);

    var stoppedTransaction = false;

    if (requestNo != me.requestNo) {

        me.messageText = "KEIN ERGEBNIS!";
        var extMessageText = me.messageText +
            " (erwartete Anforderung: " + me.requestNo +
            ", erhalten: " + requestNo + ")";
        me.bankomat.dump(me.extMessageText);
        me.bankomat.answerComp.onCancelTransaction(me.bankomat.answerComp,
            me.messageText);
        log.add(2, "Warning", "Got wrong request. ")
            /*try {
            me.bankomat.stopTransaction("ENQ");
            stoppedTransaction = true;
            } catch (e) {
            log.add(2, "Error", "Wrong request: Tried to stop non-running transaction!");
            }*/
        POS.timeout.unregister("CBankomat.timeout");
        if (me.bankomat.isDebitBuy)
            me.bankomat.onBKManual();
        /*defret.resolve(-1);
        return defret.promise();*/
        return me.bankomat.stopTransaction('NAK');
    }

    switch (me.responseType) {
        // Debit Card Messages
        //
        case 'P': // Positive
            me.bankomat.isDebitBuy = false;
            /*if (!stoppedTransaction) {
            try {
            me.bankomat.stopTransaction();
            } catch (e) {
            log.add(2, "Error", "Case P: Tried to stop non-running transaction!");
            }
            }*/
            POS.timeout.unregister("CBankomat.timeout");

            if (me.bankomat.awaited != me.businessCase) {
                me.messageText = "KEIN ERGEBNIS!";
                me.sendDisplayMessage(me.messageText);
                me.bankomat.answerComp.onCancelTransaction(
                    me.bankomat.answerComp,
                    me.messageText);

                //return 0;
                return me.bankomat.stopTransaction();
            }

            switch (me.businessCase) {
                case '0': // purchase
                    voucher = new CDebitVoucher();

                    // determine version no
                    var version = message.charAt(1);
                    // determine card type
                    var type = message.substr(44, 3);
                    var re = /(KMC|KVI|KDI|KAM|KJB)/;
                    var matches = re.exec(type);
                    if (matches != null) {
                        // credit card payment with PIN
                        var cccTag = matches[0];
                        if (cccTag == 'KMC')
                            voucher.resultText = "MASTERCARD ";
                        else if (cccTag == 'KVI')
                            voucher.resultText = "VISA ";
                        else if (cccTag == 'KDI')
                            voucher.resultText = "DINERS ";
                        else if (cccTag == 'KAM')
                            voucher.resultText = "AMERICAN EXPRESS ";
                        else if (cccTag == 'KJB')
                            voucher.resultText = "JCB ";
                        else
                            voucher.resultText = cccTag + " ";

                        me.messageText = voucher.resultText;
                        me.messageText += "\nEUR " + message.substr(51, 9);
                        voucher.resultText += message.substr(49, 11);
                    } else if (type == 'B-K' || type == 'edc' || type == 'QCK') {
                        // debit card payment
                        if (type == 'B-K' || type == 'edc')
                            voucher.resultText = "Maestro ";
                        else
                            voucher.resultText = "Quick ";

                        me.messageText = voucher.resultText;
                        me.messageText += "\nEUR " + message.substr(51, 9);
                        voucher.resultText += message.substr(49, 11);
                    } else {
                        me.messageText = message.substr(44, 3);
                        me.messageText += "\nEUR " + message.substr(51, 9);
                        voucher.resultText = message.substr(44, 16);
                    }

                    if (version == '1') // version 2 of P-set
                    {
                        voucher.subscriptionField = (message.charAt(61) == '1');
                        var num = parseInt(message.charAt(62));
                        var offset = 63;
                        var size = 33;
                        for (var i = 0; i < num; i++) {
                            voucher.voucherRows.push(message.substr(offset, size));
                            offset += size;
                        }
                    }

                    voucher.result = message.substr(4, 40);

                    me.bankomat.answerComp.onDebitCardTransaction(
                        me.bankomat.answerComp,
                        me.messageText, voucher);
                    //return 0;
                    return me.bankomat.stopTransaction('ACK');
                    break;

                case '2': // balance or shift sum
                case '3':
                case 'A':
                    voucher = new CDebitBalanceVoucher();
                    voucher.sum = parseFloat(remEuropeanComma(message.substr(8, 12)));
                    voucher.result = message.substr(4, 40);
                    voucher.messageText = message.substr(44, 16);
                    var vr = "T-K:";
                    var sign = " ";
                    if (me.bankomat.tkSum < 0)
                        sign = "-";

                    me.bankomat.tkSum = Math.abs(parseFloat(me.bankomat.tkSum));
                    me.bankomat.tkSum = float2StringD2(me.bankomat.tkSum);

                    vr += sign;
                    vr += prepareFixedLength(11, " ", me.bankomat.tkSum);
                    vr += "           TES-Kasse";

                    voucher.voucherRows.push(vr);

                    me.messageText = message.substr(44, 16);

                    $.when(voucher.print(me.businessCase == '3')).done(function() {

                        me.bankomat.tkSum = 0;

                        me.bankomat.answerComp.onDebitCardBalance(
                            me.bankomat.answerComp,
                            me.messageText, voucher);
                        $.when(me.bankomat.stopTransaction('ACK')).done(function() {
                            defret.resolve();
                        });
                    });
                    return defret.promise();
                    break;

            }
            return 0;
            break;
        case 'N': // Negative credit card tx
	    window.clearTimeout(me.bankomat.timeoutId);
            me.bankomat.isDebitBuy = false;
            /*if (!stoppedTransaction) {
            try {
            me.bankomat.stopTransaction();
            } catch (e) {
            log.add(2, "Error", "Case N: Tried to stop non-running transaction!");
            }
            }*/
            POS.timeout.unregister("CBankomat.timeout");

            me.messageText = message.substr(4, 16);

            if (me.messageText.charAt(0) == '*') {
                me.bankomat.answerComp.onRetryTransaction(
                    me.bankomat.answerComp,
                    me.messageText,
                    me.bankomat.callback,
                    me.bankomat.callbackParams);
            } else {
                me.sendDisplayMessage(me.messageText);
                me.bankomat.answerComp.onCancelTransaction(
                    me.bankomat.answerComp,
                    me.messageText);
            }
            break;

            // Credit Card Messages go here ...
            //
        case 'H': // hold message
            POS.timeout.unregister("CBankomat.timeout");
            if (typeof me.bankomat.timeoutId != undefined)
                window.clearTimeout(me.bankomat.timeoutId);
            var args = new Array(me.bankomat, me.requestNo, "");
            me.bankomat.waiting = true;
            if (typeof me.bankomat.timeoutId != undefined)
                me.bankomat.timeoutId = window.setTimeout(
                    me.bankomat.timeout,
                    me.bankomat.timer * 2000,
                    args);
            else
                POS.timeout.register("CBankomat.timeout",
                    me.bankomat.timeout,
                    args,
                    me.bankomat.timer * 8,
                    1);
            return me.bankomat.stopTransaction(); //no reply??
            break;
        case 'M': // business request result
            /*if (!stoppedTransaction) {
            try {
            me.bankomat.stopTransaction();
            } catch (e) {
            log.add(2, "Error", "Case M: Tried to stop non-running transaction!");
            }
            }*/
            POS.timeout.unregister("CBankomat.timeout");
	window.clearTimeout(me.bankomat.timeoutId);
            POS.hourGlass.hide();
            POS.bankomatActive = false;

            voucher = new CCreditCardVoucher(me.bankomat.isCopy);

            switch (me.businessCase) {
                case '8':
                    me.bankomat.answerComp.Main.BonManager.printMode = "bill";
                case '9':
                    voucher.refAmount = message.substr(116, 8);
                    voucher.refVoucher = message.substr(124, 6);
                default:
                    voucher.ccc = message.substr(5, 20);
                    voucher.creditCardNo = message.substr(25, 21);
                    voucher.expiration = message.substr(46, 5);
                    voucher.source = message.charAt(51);
                    voucher.traderNo = message.substr(52, 16);
                    voucher.terminalId = message.substr(68, 9);
                    voucher.voucherNo = message.substr(76, 6);
                    voucher.acceptanceNo = message.substr(82, 6);
                    voucher.resultText = message.substr(88, 20);
                    voucher.amount = cent2Euro(message.substr(108, 8));
		voucher.signature = true;
            }

            me.bankomat.isCopy = false;
            me.messageText = message.substr(130, 16);

            // Left transactions
            var anzahl = message.substr(146, 4);
            anzahl = parseFloat(anzahl);
            if (anzahl < 11) // only 10 transactions left
            {
                me.bankomat.answerComp.onTransactionShortage(anzahl);
            }

            // Print salesman voucher for customer's signature
            $.when(voucher.print()).done(function() {

                // was soll das denn??? kommt hier eventuell der unsinn mit
                // OK und CANCEL-buttons, die nacheinander auftauchen, zustande?
                // todo !!! debug !!!
                if (me.businessCase == 9) // after cancellation
                {
                    if (me.bankomat.answerComp.doCancel)
                        me.bankomat.answerComp.doCancel(me.messageText);
                    else {
                        me.sendDisplayMessage(me.messageText);
                        POS.bankomatActive = false;
                    }
                    $.when(me.bankomat.stopTransaction('ACK')).done(function() {
                        defret.resolve();
                    });
                    return;
                }

                if (typeof me.bankomat.answerComp.onCreditCardTransaction == "function") {
                    me.bankomat.answerComp.onCreditCardTransaction(
                        me.bankomat.answerComp,
                        me.messageText,
                        voucher);
                }
                me.bankomat.isCopy = false;
                $.when(me.bankomat.stopTransaction('ACK')).done(function() {
                    defret.resolve();
                });
            });
            return defret.promise();
            break;
        case 'L': // business request cancellation
            /*if (!stoppedTransaction) {
            try {
            me.bankomat.stopTransaction();
            } catch (e) {
            log.add(2, "Error", "Case L: Tried to stop non-running transaction!");
            }
            }*/
            POS.timeout.unregister("CBankomat.timeout");

            POS.hourGlass.hide();
            POS.bankomatActive = false;

            me.messageText = message.substr(5, 16);
            if (me.messageText.charAt(0) == '*') // retrying makes sense
            {
                //                    if (me.businessCase == 'K')   // we may redemand credit card
                // data
                if (me.businessCase == '2') // Lesefehler
                {
                    me.bankomat.answerComp.manualCardNumber(
                        me.bankomat.answerComp);
                    return;
                } else {
                    me.bankomat.answerComp.onRetryTransaction(
                        me.bankomat.answerComp,
                        me.messageText,
                        me.bankomat.callback,
                        me.bankomat.callbackParams);
                    return;
                }
            }
            me.sendDisplayMessage(me.messageText);
            me.bankomat.answerComp.onCancelTransaction(
                me.bankomat.answerComp,
                me.messageText);

            break;
        case 'S': // administration request cancellation
            /*if (!stoppedTransaction) {
            try {
            me.bankomat.stopTransaction();
            } catch (e) {
            log.add(2, "Error", "Case S: Tried to stop non-running transaction!");
            }
            }*/
            POS.timeout.unregister("CBankomat.timeout");
            me.messageText = message.substr(5, 16);
            me.messageText = message.substr(5, 16);
            me.sendDisplayMessage(me.messageText);
            me.bankomat.answerComp.onCancelTransaction(me.bankomat.answerComp,
                me.messageText);

            break;
        case 'T': // administration request result, header
            voucher = new CCreditBalanceVoucher();
            voucher.terminalId = message.substr(5, 8);
            voucher.czId = message.substr(13, 2);
            voucher.rowSetCount = message.substr(31, 2);
            voucher.bargainText = message.substr(33, 20);
            voucher.cancelText = message.substr(53, 20);
            voucher.adviceText = message.substr(73, 20);

            me.messageText = message.substr(15, 16);
            var vouchercomplete = function() {
                POS.timeout.unregister("CBankomat.timeout");
                clearTimeout(me.to);

                $.when(voucher.print()).done(function() {
                    me.bankomat.answerComp.onCreditCardBalance(me.bankomat.answerComp,
                        me.messageText,
                        voucher);
                    $.when(me.bankomat.stopTransaction('ACK')).done(function() {
                        defret.resolve();
                    });
                });
            }
            me.to = window.setTimeout(
                vouchercomplete,
                30000);

            break;
        case 'U': // administration request result, rowset
            {
                var dataSet = new CBalanceDataSet;
                var defret = jQuery.Deferred();

                switch (me.businessCase) {
                    case '3': // difference exists
                        dataSet.type = 32;
                        dataSet.diffSign = message.charAt(128);
                        dataSet.diff = cent2Euro(message.substr(129, 10));
                    case '1': // accounts repeated
                        dataSet.type |= 16;
                    case '2': // accounts accomplished successfully
                        dataSet.type |= 8;
                        dataSet.barAmount = cent2Euro(message.substr(86, 10));
                        dataSet.barCount = message.substr(96, 4);
                        dataSet.cancelAmount = cent2Euro(message.substr(100, 10));
                        dataSet.cancelCount = message.substr(110, 4);
                        dataSet.adviceAmount = cent2Euro(message.substr(114, 10));
                        dataSet.adviceCount = message.substr(124, 4);
                    case '5': // made internal sums without clearing them
                        dataSet.type |= 4;
                    case '6': // made internal sums and cleared them
                        dataSet.type |= 2;
                        dataSet.sumSign = message.charAt(75);
                        dataSet.sum = cent2Euro(message.substr(76, 10));
                    case '4': // cancelled accounts
                        dataSet.type |= 1;
                        dataSet.rowSetNo = message.substr(5, 2);
                        dataSet.ccc = message.substr(7, 20);
                        dataSet.traderNo = message.substr(27, 16);
                        dataSet.resultText = message.substr(43, 20);
                        dataSet.accountsDate = message.substr(63, 6);
                        dataSet.accountsTime = message.substr(69, 6);
                        if (me.businessCase == '4') // cancelled accounts have to reset sum
                            dataSet.sum = null;
                }

                if (me.businessCase == '1')
                    dataSet.isCopy = true;

                voucher.dataSets.push(dataSet);
                //dump(voucher.toString() + "\n");
                if (voucher.complete()) {
                    /*if (!stoppedTransaction) {
                    try {
                    me.bankomat.stopTransaction();
                    } catch (e) {
                    log.add(2, "Error", "Case U: Tried to stop non-running transaction!");
                    }
                    }*/
                    POS.timeout.unregister("CBankomat.timeout");
                    clearTimeout(me.to);

                    $.when(voucher.print()).done(function() {
                        me.bankomat.answerComp.onCreditCardBalance(me.bankomat.answerComp,
                            me.messageText,
                            voucher);
                        $.when(me.bankomat.stopTransaction('ACK')).done(function() {
                            defret.resolve();
                        });
                    });

                } else {
                    $.when(me.bankomat.stopTransaction('ACK')).done(function() {
                        defret.resolve();
                    });
                }
                return defret.promise();
            }

            break;

    }

    return me.bankomat.stopTransaction('ACK');
}

CBankomatHandler.prototype.sent = function() {
    dump("EVENT Sent\n");
}

CBankomatHandler.prototype.error = function(message) {
    POS.Bankomat.handler.sendDisplayMessage("B-KASSE ??");
    POS.Bankomat.dump(message);
    POS.hourGlass.hide();
    POS.bankomatActive = false;
    POS.timeout.unregister("CBankomat.timeout");
    //POS.Bankomat.stopTransaction("ACK");
    if (POS.Bankomat.answerComp != undefined) {
        POS.Bankomat.answerComp.onLowLevelError(
            POS.Bankomat.answerComp,
            message);
        if (POS.Bankomat.isDebitBuy)
            POS.Bankomat.onBKManual();
    }
    return POS.Bankomat.stopTransaction("ACK");
    //alert("Here I am!");
    /*
	try {
	me.endTransaction();
	} catch (e)
{
	//dump("error: " + vt.getLastError());
	}
	POS.Bankomat.dump(message);
	POS.timeout.unregister("CBankomat.checkstatus");
	POS.hourGlass.hide();
	POS.bankomatActive = false;
	POS.Bankomat = new CBankomat();
	var Main = POS.sessions.getSessionComponent();
	if (typeof Main.BonManager.cmpBCC != "undefined" && Main.BonManager.cmpBCC.transmitted == true)
	Main.BonManager.cmpBCC.doCancel();
	//this.bankomat.answerComp.onLowLevelError(this.bankomat.answerComp, message);
	//dump("EVENT Error: " + message + "\n");
	 */
}

CBankomatHandler.prototype.QueryInterface = function(iid) {
    if (!iid.equals(Components.interfaces.nsIVisoTechATMEvents) &&
        !iid.equals(Components.interfaces.nsISupports)) {
        throw Components.results.NS_ERROR_NO_INTERFACE;
    }
    return this;
}

CBankomatHandler.prototype.sendDisplayMessage = function(message) {

    try {
        expr = /\n/;
        messages = message.split(expr);
        this.Display.addLine();
        this.Display.addElement(messages[0], 0, 0, 0, 19);
        this.Display.addLine();
        if (messages.length > 1)
            this.Display.addElement(messages[1].trim(), 0, 0, 0, 19);
        else
            this.Display.addElement("", 9, 2, 0, 19);
        this.Display.out();
    } catch (e) {}
}

CBankomatHandler.prototype.lowLevel = function(me, data) {

    var defret = jQuery.Deferred();

    ////
    if (me.lowlevelto) {
        clearTimeout(me.lowlevelto);
    }
    me.lowlevelto = setTimeout(me.lowleveltimeout, 10000, me);
    ////

    if (data[0] == 5) { //ENQ
        //send ACK oder Daten
        //if (data.length == 1) {
        if (!me.ready) {
            //log.add(1, "Info B-Kasse", "Not ready, Send nothing", null);
            me.dataReceived = new Buffer([]);
            //me.ready = true;
            //return 0;
            //send nothing
            return me.stopTransaction();
        }
        me.ready = false;
        if (me.dataToSend) {
            $.when(me.sendData(me, me.dataToSend)).then(function() {
                me.ready = true;
                defret.resolve();
            });
            return defret.promise();
        } else {

            /*$.when(me.sendData(me, new Buffer([0x6]))).then(function () { //ACK
            me.ready = true;
            defret.resolve();
            });
            return defret.promise();*/
            return me.stopTransaction('ACK', null, true); //send ack, kein logging
        }

    } else if (data[0] == 6) { //ACK
        if (data.length == 1) {
            console.log('data von Terminal bestätigt received ACK');
            log.add(1, "Info B-KAsse", "Data von Terminal bestätigt received ACK", null);
            return 0;
        }
    } else if (data[0] == 21) { //NAK
        console.log('data von Terminal erhalten und nicht verstanden Receive NAK');
        log.add(1, "Info B-Kasse", "Data von Terminal NICHT bestätigt received NAK", null);
        return me.handler.error("Bankomat-Kasse hat Anfrage nicht verstanden!");
        //return 0;
    } else if (data[0] == 2) { //STX
        log.add(1, "Info B-Kasse", "Data von Terminal erhalten STX", null);
        //console.log('data von Terminal erhalten');
    } else { // data abgeschnitten
        console.log('data von Terminal erhalten KEIN STX');
        //log.add(1, "Info B-Kasse", "Data von Terminal erhalten OHNE STX", null);
        /*if (!me.dataReceived) {
        return me.sendData(me, new Buffer([0x15])); //NAK, dann fehlt erster Teil mit STX
        //return;
        }*/
    }
    me.ready = false;
    me.dataReceived = Buffer.concat([me.dataReceived, data]);
    var position2 = me.findByteInBuffer(me.dataReceived, 2); //STX
    var position3 = me.findByteInBuffer(me.dataReceived, 3); //ETX
    if (position2 > -1 && position3 < 0) { //dann noch nicht das Ende der Nachricht
        //me.dataReceived = data;
        if (position2 > 0) {
            me.dataReceived = me.dataReceived.slice(position2, me.dataReceived.length); //vorderen Teil abschneiden
        }
        me.ready = true;
        return 0;
    } else if (position2 < 0) {
        log.add(1, "Info B-Kasse", "Send  NAK da STX fehlt " + me.dataReceived.toString() + ", " + JSON.stringify(me.dataReceived), null);
        me.dataReceived = new Buffer([]); //BUffer leeren
        console.log('send  NAK da STX fehlt');
        /*$.when(me.sendData(me, new Buffer([0x15]))).then(function () { //NAK da STX fehlt
        me.ready = true;
        defret.resolve();
        });*/
        return me.stopTransaction('NAK');
        //return  = 0;
    } else if (position2 < 0 && position3 < 0) {
        log.add(1, "Info B-Kasse", "STX und ETX fehlt, Buffer wird geleert: " + me.dataReceived.toString() + ", " + JSON.stringify(me.dataReceived), null);
        me.dataReceived = new Buffer([]); //BUffer leeren
        //me.ready = true;
        return me.stopTransaction();
    }
    //me.dataReceived = null;
    var lrcatm = me.dataReceived.slice(position3 + 1, position3 + 2);
    if (lrcatm.length < 1) {
        log.add(1, "Info B-Kasse", 'LRC noch nicht erhalten, unvollständig -> return ', null);
        return 0;
    }
    var message = me.dataReceived.slice(1, position3);
    var lrc = me.calculateLRC(me.dataReceived.slice(1, position3 + 1));

    if (lrc[0] != lrcatm[0]) {
        console.log('send  NAK da LRC falsch');
        log.add(1, "Info B-Kasse", "Send  NAK da LRC falsch, Daten: " + message.toString('ascii') + "," + JSON.stringify(me.dataReceived), null);
        me.dataReceived = new Buffer([]);
        return me.stopTransaction('NAK');
        /*$.when(me.sendData(me, new Buffer([0x15]))).then(function () { //NAK
        me.ready = true;
        defret.resolve();
        });
        return defret.promise();*/
        //return;
    }
    me.dataReceived = me.dataReceived.slice(position3 + 2, me.dataReceived.length);
    var d = message.toString('ascii');
    console.log('data received: ' + d);
    log.add(1, "Info B-Kasse", 'data received: ' + d, null);
    if (d == me.previousResponse) {
        log.add(1, "Info B-Kasse", 'Antwort schon erhalten-> return send ACK ', null);
        return me.stopTransaction('ACK');
        /*$.when(me.sendData(me, new Buffer([0x6]))).then(function () {
        me.ready = true;
        defret.resolve();
        });
        return defret.promise();*/
    }

    me.previousResponse = d;

    $.when(me.getRequestNo()).then(function(reqNo) {
        if (reqNo == null) {
            log.add(1, "Error", "Could not retrieve RequestNo ");
        } else {
            me.handler.requestNo = reqNo;
        }
        $.when(me.handler.response(d)).then(function(ret) {
            me.dataReceived = new Buffer([]); //BUffer leeren
            defret.resolve();

        });
    });
    return defret.promise();
}

// ---------------------------------------------------------------------------
// CBankomat
//  Provides access to bankomat terminal
// ---------------------------------------------------------------------------
function CBankomat() {
    // File for dumping
    this.dumpFile = new CFileHandler();
    this.dumpFile.fileName = "var/log/posdump.log";

    this.requestNo = 0;
    this.timer = 40;
    this.lastCase = -1;
    this.waiting = false;
    this.answerComp = null;
    this.handler = new CBankomatHandler(this);

    this.awaited = null;

    this.isDebitBuy = false;

    this.running = false;
    this.init();
    if (POS.EnvProperties.DEBUGBK == "YES") {
        this.Debug = 1;
    } else {
        this.Debug = 0;
    }

}

CBankomat.prototype.init = function() {
    dump("startup\n");
    /*privMan.enablePrivilege (privList);
    var vt = Components.classes["@visotech.at/VisoTech;1"].createInstance(Components.interfaces.nsIVisoTech);*/
    //var comPort = ;
    var me = this;
    this.dataToSend = new Buffer([]);
    this.dataReceived = new Buffer([]);
    this.ready = true;
    var SerialPort = require("serialport").SerialPort;
    try {
        //this.listener = vt.initATMListener("/dev/ttyS" + comPort);
        if (!this.serialport) {
            this.serialport = new SerialPort(POS.EnvProperties.BANKOMATTERMINALPORT, {
                    //this.fp = new SerialPort("/dev/ttyS2", {
                    baudrate: 9600,
                    dataBits: 7,
                    parity: 'even',
                    stopBits: 1

                },
                false);
            /*this.serialport = new SerialPort(POS.EnvProperties.BANKOMATTERMINALPORT, {
            			//this.fp = new SerialPort("/dev/ttyS2", {
            			baudrate : 115200

            		},
            			false);*/
            //this.serialport = new SerialPort(POS.EnvProperties.BANKOMATTERMINALPORT,null,false);
            this.serialport.open(function(error) {
                if (error) {
                    var e = new Error();
                    var stack = e.stack.replace(/^[^\(]+?[\n$]/gm, '')
                        .replace(/^\s+at\s+/gm, '')
                        .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@')
                        .split('\n');
                    console.log('failed to open: ' + error + ",stck:" + stack);
                    log.add(1, "Error B-Kasse", 'failed to open: ' + error + ",stck:" + stack, null);
                    me.running = false;
                } else {
                    console.log('ATM open');
                    log.add(1, "Info B-Kasse", 'Schnittstelle zur B-Kasse geöffnet', null);

                    //Send all Lines to printer
                    //go through all lines

                }

            });
        }

        this.serialport.on('data', function(data) {
            console.log('received data:' + data.toString());
            if (me.Debug == 1) {
                me.dump("RX:'" + data + "'");
            }
            me.running = true;
            $.when(ret = me.handler.lowLevel(me, data)).then(function() {

                //me.ready = true;
                //log.add(1, "Info B-Kasse", "Now ready", null);
            });
        });

    } catch (e) {
        //dump("error: " + vt.getLastError());
        dump("error: " + e);
    }
    //this.listener.setEventHandler(this.handler);
    //if (this.running == false) {
    //	POS.timeout.register("CBankomat.checkstatus", this.checkstatus, new Array(this), 2);

    //}
}

CBankomat.prototype.findByteInBuffer = function(buffer, b) {

    for (i = 0; i < buffer.length; i++) {
        if (buffer[i] == b)
            return i;
    }
    return -1;

}

CBankomat.prototype.checkstatus = function(args) {
    var me = args[0];
    /*privMan.enablePrivilege (privList);*/
    //me.listener.process();
}

CBankomat.prototype.startTransaction = function() {
    //var args = new Array(this, null, new Buffer([0x2]));
    //this.sendData(this, new Buffer([0x2]));
}

CBankomat.prototype.stopTransaction = function(answer, delprev, nolog) {
    //var args = new Array(this, null, new Buffer([0x15])); //NAK ??
    //var buf = new Buffer([0x6]); //ACK
    var me = this;
    var defret = jQuery.Deferred();
    if (delprev)
        me.previousResponse = "";
    if (answer == 'NAK') { //z.B.: requestNo falsch
        $.when(me.sendData(me, new Buffer([0x15]))).then(function() { //NAK
            me.ready = true;
            log.add(1, "Info B-Kasse", 'send NAK ', null);
            defret.resolve();
        });
    } else if (answer == 'ACK') {
        $.when(me.sendData(me, new Buffer([0x6]))).then(function() { //ACK
            me.ready = true;
            if (nolog) {} else {
                log.add(1, "Info B-Kasse", 'send ACK', null);
            }
            defret.resolve();
        });
    }
    /*if (me.dataReceived.length > 1) {
    $.when(me.handler.lowLevel(me, me.dataReceived)).done(function () {
    console.log('send ACK Daten erfolgreich erhalten: ' + d);
    log.add(1, "Info B-Kasse", 'send ACK Daten erfolgreich verarbeitet ', null);
    $.when(me.sendData(me, new Buffer([0x6]))).then(function () {
    me.ready = true;
    defret.resolve();
    });

    });*/
    else { //send no reply
        me.ready = true;
        defret.resolve();
        //}
    }
    return defret.promise();
    //$.when(this.sendData(this, buf)).done(function () {});
}

CBankomat.prototype.dump = function(dumpText) {
    var dateTime = currentDateString() + " " + currentTimeString("hh:MM:ss");
    this.dumpFile.open(true);
    this.dumpFile.append(dateTime + "> " + dumpText + "\n");
}

// ---------------------------------------------------------------------------
// Business methods
//  each with:
//  - "original" function
//  - callback version for reexecution with same parameters
// ---------------------------------------------------------------------------

CBankomat.prototype.buyDebit = function(amount, bonId, answerComp) {
    this.isDebitBuy = true;
    this.answerComp = answerComp;
    var BankomatClass = this;
    amount = parseFloat(amount);
    var timeoutStr = expandInteger(this.timer, 3);
    $.when(this.generateRequestNo()).then(function(requestNo) {
        // Prepare callback for recall of this method
        log.add(1, "B-Kassa", 'buyDebit RequestNo generiert: ' + requestNo, null);
        BankomatClass.callback = BankomatClass.buyDebitCallback;
        BankomatClass.callbackParams = new Array(amount, bonId, answerComp);

        // Universalzahlungsart
        var requestString =
            "A014" +
            expandInteger(fix2Decimals(amount * 100), 8) +
            parseInt(requestNo) +
            "00" +
            BankomatClass.getSalesmanAccountId() +
            "0" + // no exception
            "99" + // no restriction
            "000000" // no delay
        ;
        /*
        var requestString =
        "A01U"                 +
        expandInteger(fix2Decimals(amount * 100), 8)+
        parseInt(requestNo)    +
        "00"                   +
        BankomatClass.getSalesmanAccountId() +
        "0"                    +    // no exception
        "99"                   +    // no restriction
        "000000"                    // no delay;
         */
        var args = new Array(BankomatClass, requestNo, requestString);
        BankomatClass.awaited = '0';
        POS.timeout.register("CBankomat.sendMessage", BankomatClass.sendMessage, args, 2, 1);

        var timeoutArgs = new Array(BankomatClass, requestNo, "");
        BankomatClass.waiting = true;
        POS.timeout.register("CBankomat.timeout",
            BankomatClass.timeout,
            timeoutArgs,
            BankomatClass.timer * 8, 1);
    });
}

// Callback for buyDebit
CBankomat.prototype.buyDebitCallback = function(params) {
    if (params.length == 3) {
        var amount = params[0];
        var bonId = params[1];
        var answer = params[2];

        POS.Bankomat.buyDebit(amount, bonId, answer);
    } else
        POS.Bankomat.dumpCallback("buyDebit");
}

CBankomat.prototype.buyCredit = function(amount, bonId, answerComp) {
    this.answerComp = answerComp;
    var BankomatClass = this;
    amount = parseFloat(amount);
    var timeoutStr = expandInteger(this.timer, 3);
    $.when(this.generateRequestNo()).then(function(requestNo) {
        // Prepare callback for recall of this method
        BankomatClass.callback = BankomatClass.buyCreditCallback;
        BankomatClass.callbackParams = new Array(amount, bonId, answerComp);
        log.add(1, "B-Kassa", 'buyCredit RequestNo generiert: ' + requestNo, null);
        // Kreditkartenzahlung
        var requestString =
            "K01" +
            timeoutStr +
            "2" +
            parseInt(requestNo) +
            expandInteger(fix2Decimals(amount * 100), 8) +
            expandInteger(bonId, 10) +
            "000000" +
            "0";
        var args = new Array(BankomatClass, requestNo, requestString);
        POS.timeout.register("CBankomat.sendMessage", BankomatClass.sendMessage, args, 2, 1);

        var timeoutArgs = new Array(BankomatClass, requestNo, "");
        BankomatClass.waiting = true;
        POS.timeout.register("CBankomat.timeout",
            BankomatClass.timeout,
            timeoutArgs,
            BankomatClass.timer * 8, 1);
    });
}

// Callback for buyCredit
CBankomat.prototype.buyCreditCallback = function(params) {
    if (params.length == 3) {
        var amount = params[0];
        var bonId = params[1];
        var answer = params[2];

        POS.Bankomat.buyCredit(amount, bonId, answer);
    } else
        POS.Bankomat.dumpCallback("buyCredit");
}

CBankomat.prototype.creditAdvice = function(amount, bonId, answerComp) {
    var BankomatClass = this;
    this.answerComp = answerComp;
    var timeoutStr = expandInteger(this.timer, 3);
    $.when(this.generateRequestNo()).then(function(requestNo) {
        amount = parseFloat(amount);
        log.add(1, "B-Kassa", 'creditAdvice RequestNo generiert: ' + requestNo, null);
        // prepare callback
        BankomatClass.callback = BankomatClass.creditAdviceCallback;
        BankomatClass.callbackParams = new Array(amount, bonId, answerComp);

        // prepare request
        var requestString =
            "K01" +
            timeoutStr +
            "8" +
            parseInt(requestNo) +
            expandInteger(fix2Decimals(amount * 100), 8) +
            expandInteger(bonId, 10) +
            "000000" +
            "0";

        var args = new Array(BankomatClass, requestNo, requestString);
        POS.timeout.register("CBankomat.sendMessage", BankomatClass.sendMessage, args, 2, 1);

        var timeoutArgs = new Array(BankomatClass, requestNo, "");
        BankomatClass.waiting = true;
        POS.timeout.register("CBankomat.timeout",
            BankomatClass.timeout,
            timeoutArgs,
            BankomatClass.timer * 8, 1);
    });
}

CBankomat.prototype.creditAdviceCallback = function(params) {
    if (params.length == 3) {
        POS.Bankomat.creditAdvice(params[0], params[1], params[2]);
        return;
    }

    POS.Bankomat.dumpCallback("creditAdvice");
}

CBankomat.prototype.cancellation = function(amount, voucherNo, answerComp) {
    var BankomatClass = this;
    this.answerComp = answerComp;
    var timeoutStr = expandInteger(this.timer, 3);
    $.when(this.generateRequestNo()).then(function(requestNo) {
        amount = parseFloat(amount);
        log.add(1, "B-Kassa", 'cancellation RequestNo generiert: ' + requestNo, null);
        // prepare callback
        BankomatClass.callback = BankomatClass.cancellationCallback;
        BankomatClass.callbackParams = new Array(amount, voucherNo, answerComp);

        // prepare request
        var requestString =
            "K01" +
            timeoutStr +
            "9" +
            parseInt(requestNo) +
            expandInteger(fix2Decimals(amount * 100), 8) +
            "0000000000" +
            expandInteger(voucherNo, 6) +
            "0";

        var args = new Array(BankomatClass, requestNo, requestString);
        POS.timeout.register("CBankomat.sendMessage", BankomatClass.sendMessage, args, 2, 1);

        var timeoutArgs = new Array(BankomatClass, requestNo, "");
        BankomatClass.waiting = true;
        POS.timeout.register("CBankomat.timeout",
            BankomatClass.timeout,
            timeoutArgs,
            BankomatClass.timer * 8, 1);
    });
}

CBankomat.prototype.cancellationCallback = function(params) {
    if (params.length != 3) {
        POS.Bankomat.dumpCallback("cancellation");
        return;
    }
    POS.Bankomat.cancellation(params[0], params[1], params[2]);
}

CBankomat.prototype.resendVoucher = function(answerComp) {
    var BankomatClass = this;
    this.answerComp = answerComp;
    var timeoutStr = expandInteger(this.timer, 3);
    $.when(this.generateRequestNo()).then(function(requestNo) {
        // prepare callback
        BankomatClass.callback = BankomatClass.resendVoucherCallback;
        BankomatClass.callbackParams = new Array(answerComp);
        log.add(1, "B-Kassa", 'resendVoucher RequestNo generiert: ' + requestNo, null);
        // Specialty: set flag
        BankomatClass.isCopy = true;

        // prepare request
        var requestString =
            "K00" +
            timeoutStr +
            "B" +
            parseInt(requestNo);

        var args = new Array(BankomatClass, requestNo, requestString);
        POS.timeout.register("CBankomat.sendMessage", BankomatClass.sendMessage, args, 2, 1);

        var timeoutArgs = new Array(BankomatClass, requestNo, "");
        BankomatClass.waiting = true;
        POS.timeout.register("CBankomat.timeout",
            BankomatClass.timeout,
            timeoutArgs,
            BankomatClass.timer * 8, 1);
    });
}

CBankomat.prototype.resendVoucherCallback = function(answerComp) {
    if (typeof answerComp != "string") {
        POS.Bankomat.dumpCallback("resendVoucher");
    } else {
        POS.Bankomat.resendVoucher(anserComp);
    }

}

CBankomat.prototype.redemandCardData = function(creditCardNo, expirationDate, answerComp) {
    var BankomatClass = this;
    this.answerComp = answerComp;
    var timeoutStr = expandInteger(this.timer, 3);
    $.when(this.generateRequestNo()).then(function(requestNo) {
        // prepare callback
        BankomatClass.callback = BankomatClass.redemandCardDataCallback;
        this.callbackParams = new Array(creditCardNo, expirationDate, answerComp);
        log.add(1, "B-Kassa", 'redemandCardData RequestNo generiert: ' + requestNo, null);
        // prepare request
        var requestString =
            "K00" +
            timeoutStr +
            "K" +
            parseInt(requestNo) +
            "00000000" +
            "0000000000" +
            "000000" +
            "5" +
            "3" +
            creditCardNo +
            "=" +
            expirationDate;

        var args = new Array(this, requestNo, requestString);
        POS.timeout.register("CBankomat.sendMessage", this.sendMessage, args, 2, 1);

        var timeoutArgs = new Array(this, requestNo, "");
        this.waiting = true;
        POS.timeout.register("CBankomat.timeout",
            this.timeout,
            timeoutArgs,
            this.timer * 8, 1);
    });
}

CBankomat.prototype.redemandCardDataCallback = function(params) {
    if (params.length != 3) {
        POS.Bankomat.dumpCallback("redemandCardData");
    }

    POS.Bankomat.redemandCardData(params[0], params[1], params[2]);
}

CBankomat.prototype.debitCardBalance = function(answerComp, tkSum) {

    var defret = jQuery.Deferred();
    this.answerComp = answerComp;
    this.tkSum = tkSum;
    var BankomatClass = this;
    var timeoutStr = expandInteger(this.timer, 3);
    $.when(this.generateRequestNo()).then(function(requestNo) {
        // prepare callback
        BankomatClass.callback = BankomatClass.debitCardBalanceCallback;
        BankomatClass.callbackParams = new Array(answerComp);
        log.add(1, "B-Kassa", 'debitCardBalance RequestNo generiert: ' + requestNo, null);
        BankomatClass.awaited = '2';

        // prepare request
        var requestString =
            "A005" +
            "00000000" +
            parseInt(requestNo) +
            "00" + // no staff differentiation
            "01" + // no account identification
            "0" + // not needed
            "99" + // no article code needed
            "000000"; // no delay

        var args = new Array(BankomatClass, requestNo, requestString);
        POS.timeout.register("CBankomat.sendMessage", BankomatClass.sendMessage, args, 2, 1);

        var timeoutArgs = new Array(BankomatClass, requestNo, "");
        BankomatClass.waiting = true;
        POS.timeout.register("CBankomat.timeout",
            BankomatClass.timeout,
            timeoutArgs,
            BankomatClass.timer * 8, 1);
        defret.resolve();
    });
    return defret.promise();
}

CBankomat.prototype.debitCardBalanceCallback = function(answerComp) {
    if (typeof answerComp != "string") {
        POS.Bankomat.dumpCallback("debitCardBalance");
        return;
    }

    return POS.Bankomat.debitCardBalance(answerComp);
}

CBankomat.prototype.debitCardShiftSum = function(answerComp) {

    var BankomatClass = this;
    this.answerComp = answerComp;
    var timeoutStr = expandInteger(this.timer, 3);
    $.when(this.generateRequestNo()).then(function(requestNo) {
        // prepare callback
        BankomatClass.callback = BankomatClass.debitCardShiftSumCallback;
        BankomatClass.callbackParams = new Array(answerComp);
        log.add(1, "B-Kassa", 'debitCardShiftSum RequestNo generiert: ' + requestNo, null);
        // prepare request
        var requestString =
            "A006" +
            "00000000" +
            parseInt(requestNo) +
            "00" + // no staff differentiation
            "01" + // no account identification
            "0" + // not needed
            "99" + // no article code needed
            "000000"; // no delay

        var args = new Array(BankomatClass, requestNo, requestString);
        POS.timeout.register("CBankomat.sendMessage", BankomatClass.sendMessage, args, 2, 1);

        var timeoutArgs = new Array(BankomatClass, requestNo, "");
        BankomatClass.waiting = true;
        POS.timeout.register("CBankomat.timeout",
            BankomatClass.timeout,
            timeoutArgs,
            BankomatClass.timer * 8, 1);
    });
}

CBankomat.prototype.debitCardShiftSumCallback = function(answerComp) {
    if (typeof answerComp != "string") {
        POS.Bankomat.dumpCallback("debitCardShiftSum");
        return;
    }

    POS.Bankomat.debitCardShiftSum(answerComp);
}

CBankomat.prototype.creditCardBalance = function(answerComp) {
    var BankomatClass = this;
    this.answerComp = answerComp;
    var timeoutStr = expandInteger(this.timer * 5, 3); // hard-coded 5min!!
    $.when(this.generateRequestNo()).then(function(requestNo) {
        // prepare callback
        BankomatClass.callback = BankomatClass.creditCardBalanceCallback;
        BankomatClass.callbackParams = new Array(answerComp);
        log.add(1, "B-Kassa", 'creditCardbalance RequestNo generiert: ' + requestNo, null);
        // prepare request
        var requestString = "R00" +
            timeoutStr +
            "1" + // balance
            parseInt(requestNo) +
            "99" + // all clearing centers
            "000000" +
            "0000000";

        var args = new Array(BankomatClass, requestNo, requestString);
        POS.timeout.register("CBankomat.sendMessage", BankomatClass.sendMessage, args, 2, 1);

        var timeoutArgs = new Array(BankomatClass, requestNo, "");
        BankomatClass.waiting = true;
        /*
        geht irgendwie nicht...
        POS.timeout.register("CBankomat.timeout",
        BankomatClass.timeout       ,
        timeoutArgs        ,
        BankomatClass.timer * 4 * 5, 1);
         */
        BankomatClass.timeoutId = window.setTimeout(
            BankomatClass.timeout,
            BankomatClass.timer * 1000 * 5,
            timeoutArgs);
    });
}

CBankomat.prototype.creditCardBalanceCallback = function(answerComp) {
    if (typeof answerComp != "string") {
        POS.Bankomat.dumpCallback("creditCardBalance");
        return;
    }

    POS.Bankomat.creditCardBalance(answerComp);
}

CBankomat.prototype.calculateLRC = function(message) {
    var checksum = new Buffer([0x00])[0];
    for (i = 0; i < message.length; i++) {
        checksum ^= message[i];
    }

    return new Buffer([checksum]);
}

CBankomat.prototype.sendMessage = function(args) {
    var me = args[0];
    var requestNo = args[1];
    var message = args[2];
    console.log('sendMessage: ' + message.toString());
    log.add(1, "Info B-Kasse", 'SendMessage: ' + message.toString() + ", RequestNo: " + requestNo, null);
    //if (requestNo && requestNo > -1) {
    me.handler.requestNo = requestNo;
    log.add(1, "Info B-Kasse", "me.handler.requestNo RequestNo: " + me.handler.requestNo, null);
    //}
    /*privMan.enablePrivilege (privList);*/

    // Begin transaction for every request. These transactions
    // are ended either in case of an error or when a response
    // (negative or positive) for that request is received.

    /*try {
    me.listener.startTransaction();
    } catch (e) {
    POS.timeout.unregister("CBankomat.timeout");
    me.answerComp.onCancelTransaction(me.answerComp,
    "startTransaction konnte nicht gestartet werden.");
    return;
    }*/
    if (typeof(message) == 'string') {
        var stx = new Buffer([0x2]);
        var m = new Buffer(message, 'ascii');
        var etx = new Buffer([0x3]);
        var lcr = me.calculateLRC(Buffer.concat([m, etx]));
        m = Buffer.concat([stx, m, etx, lcr]);
    } else {
        m = message;
    }
    me.dataToSend = m;
    me.handler.sendDisplayMessage("");
    //me.listener.setNextResponse(message);
}

CBankomat.prototype.sendData = function(me, message) {
    var defret = jQuery.Deferred();
    //console.log('send Data message: ' + message.toString());

    if (message.length > 1) {
        log.add(1, "Info B-Kasse", 'SendData: ' + message.toString(), null);
    }
    if (this.Debug == 1) {
        POS.Bankomat.dump("TX:'" + message + "'");
    }
    me.serialport.write(message, function(err, results) {
        if (err) {
            console.log('Message konnte nicht geschrieben werden err: ' + err);
            if (this.Debug == 1) {
                dump('Message konnte nicht geschrieben werden err: ' + err);
            }
            //serialport = null;
            POS.timeout.unregister("CBankomat.timeout");
            if (me.answerComp.onCancelTransaction) {
                me.answerComp.onCancelTransaction(me.answerComp,
                    "startTransaction konnte nicht gestartet werden.");
            }
            defret.resolve(false);
            return;
        } else {
            if (results > 1) {
                console.log('sendData results written bytes:' + results);
                log.add(1, "Info B-Kasse", 'Erfolgreich: ' + results + ' Bytes gesendet!', null);
            }
            defret.resolve(true);
        }
        me.dataToSend = null;
        //me.reset();
    });
    return defret.promise();
}

// ---------------------------------------------------------------------------
// Helper methods
// ---------------------------------------------------------------------------

CBankomat.prototype.getRequestNo = function() {
    var dfd = jQuery.Deferred();
    var sql = "SELECT RequestId FROM BKCOUNT";
    $.when(POS.SQLiteCon.execute(sql)).then(function(rows) {
        if (rows.length != 1) {
            //r.free();
            //return null;
            dfd.resolve(null);
            return;
        }
        dfd.resolve(parseInt(rows[0].RequestId));
    });
    return dfd.promise();
}

CBankomat.prototype.generateRequestNo = function() {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var me = this;
    $.when(this.getRequestNo()).then(function(requestNo) {
        if (requestNo == null) {
            dfd.resolve(null);
            return;
        }
        if (requestNo < 9)
            requestNo++;
        else
            requestNo = 0;
        me.requestNo = requestNo;
        sql = "UPDATE BKCOUNT SET RequestId = " + requestNo;
        $.when(POS.SQLiteCon.execute(sql)).done(function() {
            dfd.resolve(requestNo);
            //r.free();
            //return requestNo;
        });
    });
    return dfd.promise();
}

CBankomat.prototype.timeout = function(args) {
    var me = args[0];
    var requestNo = args[1];
    var message = args[2];

    if (me.waiting) // timed out
    {
        log.add(1, "Info B-Kasse", 'SendData: timeout', null);
    /*    POS.hourGlass.hide();
        var messageText = "KEIN ERGEBNIS!";
        var extMessageText = messageText + " (timeout)";
        me.handler.sendDisplayMessage(messageText);
        me.stopTransaction();
        me.answerComp.onCancelTransaction(me.answerComp, messageText);
        me.dump(extMessageText);*/
        me.serialport.close(function() {
            me.serialport = null;
            me.init();
        });
/*
        if (me.isDebitBuy) {
            //            me.onBKManual();
            var text = "Transaktion nicht erfolgreich! Keine Antwort vom Bankomat-Terminal.Bitte am Terminal prüfen ob Verbindung da ist. (Gr&uuml;ne OK-Taste dr&uuml;cken -> LAN und ECR in der ersten Zeile sollten gr&uuml;n sein). Gegebenenfalls Terminal neu starten.";*/
	    var text = "Noch keine Daten vom Terminal! Bitte Anschlüsse überprüfen! Sollte in den nächsten 60 Sekunden der Vorgang nicht abgeschlossen sein, bitte Kassa und Bankomat-Terminal neu starten!"
            POS.message.show(text);
       // }*/

    }

}


CBankomat.prototype.lowleveltimeout = function(me) {

    log.add(1, "Info B-Kasse", 'Lowlevel: timeout', null);
    if (me.serialport) {
        me.serialport.close(function() {
            me.serialport = null;
            me.init();
            me.lowlevelto = setTimeout(me.lowleveltimeout, 10000, me);
        });
    }

}

CBankomat.prototype.onBKManual = function() {
    this.answerComp.doCancel();
    this.isDebitBuy = false;

    var text = POS.lang.getText("MESSAGES", "CONF_PAYMENT_ON_BK_DISPLAY");
    POS.message.show(text, "question", "YESNO", this, this.doOnBKManual);
}

CBankomat.prototype.doOnBKManual = function(me, result) {

    if (result == "NO")
        return;

    voucher = new CDebitVoucher();
    voucher.resultText = "B-K MANUELL";

    me.answerComp.onDebitCardTransaction(me.answerComp, "", voucher);
}

CBankomat.prototype.getSalesmanAccountId = function() {
    var accountId = POS.EnvProperties.SALESMANACCOUNTID;
    return accountId;
    //    return "01";
}

CBankomat.prototype.dumpCallback = function(callbackName) {
    POS.Bankomat.dump("Callback \"" + callbackName + "\" failed!");
}

/*
 * HELPER FUNCTIONS
 */

function prepareFixedLength(len, fillChar, str) {
    if (typeof str == 'number')
        str = str.toString();

    var dif = len - str.length;
    var flStr = '';
    for (var i = 0; i < dif; i++) {
        flStr += fillChar;
    }

    flStr += str;

    return flStr;
}

export { CBankomatHandler, CBankomat, prepareFixedLength };
